import type { CustomerProfile, CheckStatusResponse } from '../types/customer';

export interface AuthState {
  accessToken: string | null;
  customer: CustomerProfile | null;
  customerStatus: CheckStatusResponse | null;
  isAuthLoading: boolean;
  isInitialized: boolean;
  authError: string | null;
}

export type AuthAction =
  | { type: 'SET_TOKENS'; accessToken: string; customer: CustomerProfile }
  | { type: 'SET_CUSTOMER'; customer: CustomerProfile }
  | { type: 'CLEAR_AUTH' }
  | { type: 'SET_CUSTOMER_STATUS'; status: CheckStatusResponse }
  | { type: 'SET_LOADING'; loading: boolean }
  | { type: 'SET_ERROR'; error: string | null }
  | { type: 'SET_INITIALIZED' }
  | { type: 'SIGN_OUT' };

export const initialAuthState: AuthState = {
  accessToken: null,
  customer: null,
  customerStatus: null,
  isAuthLoading: false,
  isInitialized: false,
  authError: null,
};

export function authReducer(state: AuthState, action: AuthAction): AuthState {
  switch (action.type) {
    case 'SET_TOKENS':
      return { ...state, accessToken: action.accessToken, customer: action.customer };
    case 'SET_CUSTOMER':
      return { ...state, customer: action.customer };
    case 'CLEAR_AUTH':
      return { ...state, accessToken: null, customer: null, customerStatus: null };
    case 'SET_CUSTOMER_STATUS':
      return { ...state, customerStatus: action.status };
    case 'SET_LOADING':
      return { ...state, isAuthLoading: action.loading };
    case 'SET_ERROR':
      return { ...state, authError: action.error };
    case 'SET_INITIALIZED':
      return { ...state, isInitialized: true };
    case 'SIGN_OUT':
      return { ...state, accessToken: null, customer: null, customerStatus: null, authError: null };
    default:
      return state;
  }
}
